import { render, staticRenderFns } from "./templateMultiOption.vue?vue&type=template&id=187ae6c4"
import script from "./templateMultiOption.vue?vue&type=script&lang=js"
export * from "./templateMultiOption.vue?vue&type=script&lang=js"
import style0 from "./templateMultiOption.vue?vue&type=style&index=0&id=187ae6c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports